export default {
  setTiposDocumento(state, list) {
    state.tiposDocumento = Array.isArray(list) ? list : []
  },
  setHasFetched(state, value) {
    state.hasFetched = value
  },
  setLoadError(state, err) {
    state.loadError = err
  },
  setLocalidadesTaxonomia(state, list) {
    state.localidadesTaxonomia = Array.isArray(list) ? list : []
  },
  setBarriosTaxonomia(state, list) {
    state.barriosTaxonomia = Array.isArray(list) ? list : []
  },
  setGeoTaxLoaded(state, value) {
    state.geoTaxLoaded = !!value
  },
  setGeoTaxLoadError(state, err) {
    state.geoTaxLoadError = err
  },
}
